import React from "react"
import {IEvents, IEventsCardViewProps} from "./types/events-card.types";
import {CalendarCheck2, CalendarDays, CalendarOff, Clock4} from "lucide-react";
import EmptyData from "../../common/empty-data/empty-data";
import {useNavigate} from "react-router-dom";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";
import { removeUnderScoreWithCaptialize } from "../../../utility/utility";
import dayjs  from "dayjs";
import Locale from "../../../core/locale/locale";

const EventsCardView = (props: IEventsCardViewProps) => {
    const navigate = useNavigate();

    const handleOnClick = () => {
        navigate('/highlights/our-events')
    }

    const formatDateTime=(date:string,time:string)=>{
        if(!date || !time){
            return "";
        }
       return dayjs(`${date}T${time}`).format(Locale.displayTimeShort)
    }

    const formatDate=(date:string)=>{
        if(!date){
            return '-';
        }
       return dayjs(date).format(Locale.displayDateAndMonth)
    }

    return (
        <div className={'dashboard-card dashboard-events-card'} onClick={handleOnClick}>
            <div className={'dashboard-card__header'}>
                <span className={'dashboard-card__icon-wrapper dashboard-events-card__icon-wrapper'}>
                      <CalendarCheck2 className={'dashboard-card__icon dashboard-events-card__icon'}/>
                </span>

                <h5 className={'dashboard-card__title'}>
                    {props.eventsData.type === "today"
                        ? ` Today's Events`
                        : ` Upcoming Events `
                    }
                    <p className={'dashboard-card__description'}>Never miss an event.</p>
                </h5>
                <span className={'dashboard-events-card__event-count'}>
                    {props.eventsData.data.length}{' '}Events
                </span>

            </div>
            <LoadingSkeleton loading={props.loading}>
                {
                    props.eventsData.data.length > 0 ?
                        <div className={'dashboard-events-card__content'}>
                            {props.eventsData.data.map((item: IEvents) => (
                                <div className={'dashboard-events-card__list'} key={item.id}>
                                    <div className={'event-name-and-type'}>
                                        <div className={'event-name'}>
                                            {item.name}
                                        </div>
                                        <div className={`event-type ${item.eventType}`}>
                                            {removeUnderScoreWithCaptialize(item.eventType)}
                                        </div>
                                    </div>
                                    <div className={'event-date-and-time'}>
                                        <div className={'event-date-and-icon'}>
                                            <div className={'event-calendar-icon'}>
                                                <CalendarDays/>
                                            </div>
                                            <div className={'event-date'}>
                                                {formatDate(item.startDate)}
                                            </div>
                                        </div>
                                        <div className={'event-time-and-icon'}>
                                            <div className={'event-clock-icon'}>
                                                <Clock4/>
                                            </div>
                                            <div className={'event-time'}>
                                                {formatDateTime(item.startDate,item.startTime)} -
                                                {formatDateTime(item.endDate,item.endTime)}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            ))}
                        </div>
                        :
                        <EmptyData
                            icon={<CalendarOff className={'dashboard-events-card-empty-icon'}/>}
                            title={"No Events for Upcoming!"}
                            subtitle={"Nothing coming up soon. Stay tuned!"}/>
                }
            </LoadingSkeleton>
        </div>
    )
}

export default EventsCardView;
